import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  SidebarDashboard,
  SidebarDietPlan,
  SidebarExercise,
  SidebarSleepCoach,
  SidebarMindfulness,
  SidebarPreferences,
  SidebarAdviseMe,
  SidebarFaq,
  SidebarProgressTracker,
  SidebarMyAccount,
  SidebarFitboat,
  ActiveSidebarDashboard,
  ActiveSidebarDietPlan,
  ActiveSidebarExercise,
  ActiveSidebarSleepCoach,
  ActiveSidebarMindfulness,
  ActiveSidebarPreferences,
  ActiveSidebarAdviseMe,
  ActiveSidebarFaq,
  ActiveSidebarProgressTracker,
  ActiveSidebarMyAccount,
  ActiveSidebarFitboat,
  SidebarLogout,
  SideBarQuizGame,
  ActiveSidebarQuizGame,
  MotivationSidebarActive,
  MotivationSidebar,
  WeeklyProgressSidebar,
  ActiveWeeklyProgress,
  LogoNew,
  BackImg,
  ActiveContactUs,
  ContactUs,
  YourPlan,
  ActiveYourPlans,
  ActivePremiumFeatures,
  ActiveYourResults,
  ActiveSetup,
  ActiveSupport,
  PremiumFeatures,
  YourResults,
  SetupSidebar,
  Support,
  ActiveCommunitySidebar,
  Community,
} from "@utils/defaultImages";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";

const WORDPRESS_BASE_URL = process.env.REACT_APP_WORDPRESS_URL;

const Sidebar = ({ smallScreen = false, setDrawerOpen }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const menuItems = [
    {
      name: t("sidebar.dashboard"),
      path: "/",
      icon: <SidebarDashboard className="min-w-5 min-h-5 max-w-5 max-h-5" />,
      iconActive: ActiveSidebarDashboard,
    },
    {
      name: t("sidebar.Your Plans"),
      icon: <YourPlan className="min-w-5 min-h-5 max-w-5 max-h-5" />,
      iconActive: ActiveYourPlans,
      subItems: [
        {
          name: t("sidebar.dietPlan"),
          path: "/diet-plan",
          icon: <SidebarDietPlan className="min-w-5 min-h-5 max-w-5 max-h-5" />,
          iconActive: ActiveSidebarDietPlan,
        },
        {
          name: t("sidebar.exercisePlan"),
          path: "/exercise-plan",
          icon: <SidebarExercise className="min-w-5 min-h-5 max-w-5 max-h-5" />,
          iconActive: ActiveSidebarExercise,
        },
        {
          name: t("sidebar.sleepCoach"),
          path: "/sleep-coach",
          icon: <SidebarSleepCoach className="min-w-5 min-h-5 max-w-5 max-h-5" />,
          iconActive: ActiveSidebarSleepCoach,
        },
        {
          name: t("sidebar.mindfulness"),
          path: "/mindfulness",
          icon: <SidebarMindfulness className="min-w-5 min-h-5 max-w-5 max-h-5" />,
          iconActive: ActiveSidebarMindfulness,
        },
        {
          name: t("sidebar.Motivational Coach"),
          path: "/motivational-coach",
          icon: <MotivationSidebar className="min-w-5 min-h-5 max-w-5 max-h-5" />,
          iconActive: MotivationSidebarActive,
        },
        {
          name: t("sidebar.fitbotSupport"),
          path: "/fitbot-support",
          icon: <SidebarFitboat className="min-w-5 min-h-5 max-w-5 max-h-5" />,
          iconActive: ActiveSidebarFitboat,
        },
      ],
    },
    {
      name: t("sidebar.Premium Features"),
      icon: <PremiumFeatures className="min-w-5 min-h-5 max-w-5 max-h-5" />,
      iconActive: ActivePremiumFeatures,
      subItems: [
        {
          name: t("sidebar.quizGame"),
          path: "/quiz-game",
          icon: <SideBarQuizGame className="min-w-5 min-h-5 max-w-5 max-h-5" />,
          iconActive: ActiveSidebarQuizGame,
        },
        {
          name: t("sidebar.Meet New Friends"),
          path: `${WORDPRESS_BASE_URL}/news-feed/`,
          icon: <Community className="min-w-5 min-h-5 max-w-5 max-h-5" />,
          iconActive: ActiveCommunitySidebar,
        },
        ,
      ],
    },
    {
      name: t("sidebar.Your Results"),
      icon: <YourResults className="min-w-5 min-h-5 max-w-5 max-h-5" />,
      iconActive: ActiveYourResults,
      subItems: [
        {
          name: t("sidebar.progressTracker"),
          path: "/progress-tracker",
          icon: <WeeklyProgressSidebar className="min-w-5 min-h-5 max-w-5 max-h-5" />,
          iconActive: ActiveWeeklyProgress,
        },
      ],
    },
    {
      name: t("sidebar.Setup"),
      icon: <SetupSidebar className="min-w-5 min-h-5 max-w-5 max-h-5" />,
      iconActive: ActiveSetup,
      subItems: [
        {
          name: t("sidebar.adviseMe"),
          path: "/advise",
          icon: <SidebarAdviseMe className="min-w-5 min-h-5 max-w-5 max-h-5" />,
          iconActive: ActiveSidebarAdviseMe,
        },
        {
          name: t("sidebar.preferences"),
          path: "/edit-preferences",
          icon: <SidebarPreferences className="min-w-5 min-h-5 max-w-5 max-h-5" />,
          iconActive: ActiveSidebarPreferences,
        },
        {
          name: t("sidebar.myAccount"),
          path: `${WORDPRESS_BASE_URL}/my-account/edit-account/`,
          icon: <SidebarMyAccount className="min-w-5 min-h-5 max-w-5 max-h-5" />,
          iconActive: ActiveSidebarMyAccount,
        },
      ],
    },
    {
      name: t("sidebar.Support"),
      icon: <Support className="min-w-5 min-h-5 max-w-5 max-h-5" />,
      iconActive: ActiveSupport,
      subItems: [
        {
          name: t("sidebar.faq"),
          path: `${WORDPRESS_BASE_URL}/user-faqs/`,
          icon: <SidebarFaq className="min-w-5 min-h-5 max-w-5 max-h-5" />,
          iconActive: ActiveSidebarFaq,
        },
        {
          name: t("sidebar.contactUs"),
          path: `/contact-us`,
          icon: <ContactUs className="min-w-5 min-h-5 max-w-5 max-h-5" />,
          iconActive: ActiveContactUs,
        },
      ],
    },
  ];

  const isSubItemActive = (subItems) => {
    if (!subItems) return false;
    return subItems.some((subItem) => {
      if (subItem.path === "/") {
        return (
          location.pathname === "/" ||
          location.pathname.startsWith("/dashboard")
        );
      }
      return location.pathname.startsWith(subItem.path);
    });
  };

  useEffect(() => {
    menuItems.forEach((item, index) => {
      if (isSubItemActive(item.subItems)) {
        setExpanded(`panel${index}`);
      }
    });
  }, [location.pathname]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div
      className="h-screen bg-cover text-white flex flex-col py-6 px-4 overflow-y-auto"
      style={{ backgroundImage: `url(${BackImg})` }}
    >
      <Link to="/">
        <img src={LogoNew} alt="logo" className="w-48" />
      </Link>

      <ul className="mt-4 space-y-1 flex-grow">
        {menuItems.map((item, index) => {
          const isParentActive = isSubItemActive(item.subItems);
          const panelId = `panel${index}`;

          return (
            <li key={index} className="relative rounded">
              {item.subItems ? (
                <Accordion
                  expanded={expanded === panelId}
                  onChange={handleChange(panelId)}
                  className={`bg-none p-0 ${
                    !isParentActive && "hover:bg-[#FFFFFF1A]"
                  }`}
                  sx={{
                    backgroundColor: "transparent",
                    boxShadow: "unset",
                    color: isParentActive ? "#0575E6" : "white",
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMoreIcon
                        sx={{ color: isParentActive ? "#0575E6" : "white" }}
                      />
                    }
                    sx={{
                      margin: "0",
                      backgroundColor: isParentActive ? "white" : "transparent",
                      borderRadius: "4px",
                      "& .MuiAccordionSummary-content": {
                        margin: "8px 0",
                      },
                      padding: "0px 6px",
                    }}
                  >
                    <div className="flex items-center gap-2">
                      <span>
                        {isParentActive ? (
                          <img
                            src={item.iconActive}
                            alt="sidebarIcon"
                            className="min-w-5 min-h-5 max-w-5 max-h-5"
                          />
                        ) : (
                          item.icon
                        )}
                      </span>
                      <span
                        className={
                          isParentActive ? "text-[#0575E6] font-semibold" : ""
                        }
                      >
                        {item.name}
                      </span>
                    </div>
                  </AccordionSummary>

                  <AccordionDetails
                    sx={{
                      padding: "8px 8px 8px 8px",
                      backgroundColor: "transparent",
                    }}
                  >
                    <div className="ml-2 space-y-1">
                      {item.subItems.map((subItem, subIndex) => {
                        const isActive =
                          subItem.path === "/"
                            ? location.pathname === "/" ||
                              location.pathname.startsWith("/dashboard")
                            : location.pathname.startsWith(subItem.path);

                        return (
                          <Link
                            key={subIndex}
                            to={subItem.path}
                            className={`flex items-center gap-2 pl-2 pr-4 py-2 rounded transition ${
                              isActive
                                ? "bg-white text-[#0575e6] font-semibold"
                                : isParentActive
                                  ? "hover:bg-[#FFFFFF1A] text-white"
                                  : "hover:bg-[#FFFFFF1A]"
                            }`}
                            onClick={() => {
                              if (smallScreen && setDrawerOpen) {
                                setDrawerOpen(false);
                              }
                            }}
                          >
                            <span>
                              {isActive ? (
                                <img
                                  src={subItem.iconActive}
                                  alt="sidebarIcon"
                                  className="w-5 h-5"
                                />
                              ) : (
                                subItem.icon
                              )}
                            </span>
                            <span
                              className={`${
                                isActive ? "text-[#0575e6]" : "text-white"
                              }`}
                            >
                              {subItem.name}
                            </span>
                          </Link>
                        );
                      })}
                    </div>
                  </AccordionDetails>
                </Accordion>
              ) : (
                <Link
                  to={item.path}
                  className={`flex items-center gap-2 pl-2 pr-4 py-2 rounded transition ${
                    location.pathname === item.path ||
                    (item.path === "/" &&
                      (location.pathname === "/" ||
                        location.pathname.startsWith("/dashboard"))) ||
                    (item.path !== "/" &&
                      location.pathname.startsWith(item.path))
                      ? "bg-[#F6F7FB] text-[#1980e7] font-semibold"
                      : "hover:bg-[#FFFFFF1A]"
                  }`}
                  onClick={() => {
                    setExpanded(false);
                    if (smallScreen && setDrawerOpen) {
                      setDrawerOpen(false);
                    }
                  }}
                >
                  <span>
                    {location.pathname === item.path ||
                    (item.path === "/" &&
                      (location.pathname === "/" ||
                        location.pathname.startsWith("/dashboard"))) ||
                    (item.path !== "/" &&
                      location.pathname.startsWith(item.path)) ? (
                      <img
                        src={item.iconActive}
                        alt="sidebarIcon"
                        className="w-5 h-5"
                      />
                    ) : (
                      item.icon
                    )}
                  </span>
                  <span
                    className={
                      location.pathname === item.path ||
                      (item.path === "/" &&
                        (location.pathname === "/" ||
                          location.pathname.startsWith("/dashboard"))) ||
                      (item.path !== "/" &&
                        location.pathname.startsWith(item.path))
                        ? "text-[#0575E6]"
                        : ""
                    }
                  >
                    {item.name}
                  </span>
                </Link>
              )}
            </li>
          );
        })}
      </ul>

      <Link
        to={"/logout"}
        className="w-full text-left px-4 py-2 mt-auto hover:bg-[#FFFFFF1A] rounded flex items-center gap-2 transition group"
      >
        <SidebarLogout />
        <span>{t("sidebar.logout")}</span>
      </Link>
    </div>
  );
};

export default Sidebar;
